import { useTranslation } from 'react-i18next'

import { Button, Card, CardTitle, LineItemSelector } from '@reveni-io/reveni-ui'

import Eta from './Eta/Eta'
import LineItemsToReturnCardSkeleton from './LineItemsToReturnCardSkeleton/LineItemsToReturnCardSkeleton'
import { getLineItemsToReturn } from './helpers'
import * as Styles from './styles'

const LineItemsToReturnCard = ({
  loading,
  items,
  onSelectItem,
  showPartialValidationButton,
  onGoToPartialValidationPage,
  eta,
}) => {
  const { t } = useTranslation()

  if (loading) return <LineItemsToReturnCardSkeleton />

  return (
    <Card showBorder={false}>
      <CardTitle>
        {t('Productos a devolver')}
        <Eta eta={eta} />
      </CardTitle>
      <Styles.ItemsContainer>
        {getLineItemsToReturn(items)?.map(item => (
          <LineItemSelector
            key={item.id}
            lineItem={item}
            onClick={onSelectItem}
            clickable={true}
            selected={true}
            showToggle={false}
            showStatus
            finished
            unexpectedReturn={item.is_unexpected}
          />
        ))}
      </Styles.ItemsContainer>
      {showPartialValidationButton && (
        <Button onClick={onGoToPartialValidationPage} fullWidth>
          {t('Validar devolución')}
        </Button>
      )}
    </Card>
  )
}

export default LineItemsToReturnCard
